import { hostname } from "../../services/configServices/config";

const ProductImage = ({ picture }) => {
  const imageUrl = picture
    ? hostname + picture
    : "/assets/images/default_product.jpg";
  return (
    <img
      alt=""
      className="thumb rounded"
      style={{
        width: "120px",
        height: "120px",
        objectFit: "cover",
      }}
      src={imageUrl}
    />
  );
};

export default ProductImage;
